import type { InitOptions } from "i18next";

import i18nConfig from "../../next-i18next.config";

export const FALLBACK_LOCALE = "fr";
export const supportedLocales = ["fr", "de"] as const;
export type Locales = (typeof supportedLocales)[number];

export function getOptions(lang = FALLBACK_LOCALE, ns = ["common"]): InitOptions {
  return {
    ...i18nConfig,
    fallbackLng: FALLBACK_LOCALE,
    lng: lang,
    ns,
  };
}
